<template>
  <div class="page">
    <div class="layout">
      <TheHeader></TheHeader>
      <el-row class="mobile-header" :gutter="20">
        <el-col :span="2">
          <span class="icon-button" @click="drawer = true"><i class="ri-menu-line"></i></span>
        </el-col>
        <el-col :span="18" class="mobile-title">
                <span class="title" v-if="!PageTitle">
        <span class="bigger">{{ LogoName[0] }}</span>{{ LogoName[1] }}
      </span>
          <span class="title" v-else>{{ PageTitle }}</span>
        </el-col>
        <el-col :span="2">
          <span class="icon-button" @click="onOpenNewSession"><i class="ri-chat-new-line"></i></span>
        </el-col>
        <el-col :span="2">
          <span class="icon-button" @click="toggleFont"><i class="ri-wheelchair-line"></i></span>
        </el-col>
      </el-row>
      <el-drawer
          :size="'70%'"
          :visible.sync="drawer"
          :with-header="false"
          :direction="'ltr'">
        <TheSessionHistory
            :list="sessionHistory"
            @openNewSession="onOpenNewSession"
            @click="onHistoryClick"
            @clearClick="onClearClick"
            @delSessionItem="onDelSessionItem"
        ></TheSessionHistory>
      </el-drawer>
      <div class="main">
        <div class="aside">
          <TheHot @click="onHotClick"></TheHot>
          <TheSessionHistory
            :list="sessionHistory"
            @openNewSession="onOpenNewSession"
            @click="onHistoryClick"
            @clearClick="onClearClick"
            @delSessionItem="onDelSessionItem"
          ></TheSessionHistory>
        </div>
        <div
          class="chat"
          v-bind:style="{
            backgroundImage: 'url(' + chatBgUrl + ')',
          }"
        >
          <div class="chat-wrapper">
            <div class="chat-wrap" id="chat-wrap" ref="chatWrap">
              <!-- 对话 -->
              <div
                :class="[
                  'chat-item',
                  { other: message.type == ANSWER },
                  { self: message.type == QUESTION },
                ]"
                v-for="message in messageList"
                :key="message.id"
                :id="`m-${message.id}`"
              >
                <template v-if="message.type == ANSWER">
                  <div class="avatar">
                    <img :src="robotHeadUrl" />
                    <div class="talk">{{ message.title }}</div>
                  </div>
                  <div class="message">
                    <div class="text">
                      <div class="wrap">
                        <i
                          class="el-icon-loading"
                          v-if="
                            message.status === ChatStatus.Pending ||
                            (message.status === ChatStatus.Answering &&
                              !message.content)
                          "
                        ></i>
                        <vue-markdown
                          id="currentContent"
                          v-if="false"
                          :source="message.content"
                          :anchor-attributes="anchorAttrs"
                        ></vue-markdown>
                        <the-markdown
                          id="currentContent"
                          v-if="message.status !== ChatStatus.Pending"
                          :source="message.content"
                          :think="message.think"
                          :anchor-attributes="anchorAttrs"
                        >
                        </the-markdown>
                        <div
                          v-if="
                            message.status === ChatStatus.Finished &&
                            message.answerType &&
                            message.eaUrl &&
                            message.eaUrl.length > 0
                          "
                          class="finished-tool"
                        >
                          <el-button
                            size="small"
                            type="primary"
                            @click="onShowQrCode(message)"
                            >点击扫码</el-button
                          >
                        </div>
                        <div
                          v-if="
                            message.status === ChatStatus.Finished &&
                            // message.answerType &&
                            message.rag_item &&
                            message.rag_item.length > 0
                          "
                          class="buttonContainer"
                        >
                          <el-button
                            type="text"
                            size="medium"
                            style="
                              color: #266feb;
                              border: 1px solid #dcdfe6;
                              border-radius: 20px;
                            "
                            v-for="(item, index) in rag_buttons"
                            :key="index"
                            @click="ragbuttonHandle(item)"
                            >{{ item }}</el-button
                          >
                        </div>
                        <div
                          v-if="
                            message.status === ChatStatus.Finished &&
                            message.answerType &&
                            message.matched_button &&
                            message.matched_button.length > 0
                          "
                          class="buttonContainer"
                        >
                          <el-button
                            v-for="(item, index) in buttons"
                            :key="index"
                            size="small"
                            type="primary"
                            @click="buttonHandle(message.content, item)"
                            >{{ item }}</el-button
                          >
                        </div>
                        <div
                          v-if="message.title == '为您找到这些'"
                          class="icon-buttons"
                        >
                          <el-button
                            @click="handleCopy(message.content)"
                            title="复制"
                            style="border: none; padding: 0 5px"
                          >
                            <img
                              src="@/assets/img/copy.svg"
                              alt="复制图标"
                              width="20"
                              height="20"
                            />
                          </el-button>
                          <el-button
                            @click="handleLike(message.content, message.id)"
                            title="喜欢"
                            style="border: none; padding: 0 5px"
                          >
                            <img
                              :src="likeImage"
                              alt="喜欢图标"
                              width="20"
                              height="20"
                              :id="'like' + message.id"
                            />
                          </el-button>
                          <el-button
                            @click="handleDislike(message.content, message.id)"
                            title="不喜欢"
                            style="border: none; padding: 0 5px"
                          >
                            <img
                              :src="dislikeImage"
                              alt="不喜欢图标"
                              width="20"
                              height="20"
                              :id="message.id"
                            />
                          </el-button>
                          <el-button
                            @click="handleToggleTts(message.content)"
                            title="语音开关"
                            style="border: none; padding: 0 5px"
                            v-show="
                              enableTts &&
                              message.id ===
                                messageList[messageList.length - 1].id
                            "
                          >
                            <img
                              :src="playAudioFlag ? volumeOn : volumeMute"
                              alt="语音开关图标"
                              width="20"
                              height="20"
                              :id="message.id"
                            />
                          </el-button>
                        </div>
                        <div
                          v-if="
                            message.status === ChatStatus.Finished &&
                            message.choiceList
                          "
                          class="related-matters"
                        >
                          <el-popover
                            placement="top-start"
                            title=""
                            ref="popover"
                            :visible-arrow="false"
                            width="720"
                            trigger="hover"
                            :disabled="message.choiceList.length === 0"
                            :append-to-body="false"
                          >
                            <div style="width: 100%">
                              <el-table
                                :data="message.choiceList"
                                style="width: 100%"
                              >
                                <el-table-column label="事项名称">
                                  <template slot-scope="scope">
                                    <span style="margin-left: 10px">{{
                                      scope.row
                                    }}</span>
                                  </template>
                                </el-table-column>
                                <el-table-column label="操作" width="80">
                                  <template slot-scope="scope">
                                    <el-link
                                      size="mini"
                                      type="primary"
                                      @click="handleChoiceItem(scope.row)"
                                      >查看</el-link
                                    >
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>
                            <el-button
                              slot="reference"
                              size="small"
                              type="primary"
                              @click="onGetMoreInfo(message)"
                              >相关推荐</el-button
                            >
                          </el-popover>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="message">
                    <div class="text">
                      <div class="wrap" v-html="message.content"></div>
                    </div>
                  </div>
                  <div class="avatar"  v-if="enableAvatar">
                    <img :src="userAvatarUrl" />
                  </div>
                </template>
              </div>
              <div
                class="stop-answer"
                v-show="
                  currentAnswer &&
                  currentAnswer.message &&
                  currentAnswer.message.taskId
                "
              >
                <el-button
                  class="btn-stop-answer"
                  icon="el-icon-chat-dot-square"
                  @click="onOpenNewSession"
                  >开启新对话</el-button
                >
              </div>
              <div id="pointer" style="margin-top: 140px"></div>
            </div>
          </div>
          <div class="input-wrap">
            <img :src="guideimg" class="logo" v-if="shouldShowImage" />
            <TheInput
              :status="
                currentAnswer &&
                currentAnswer.message &&
                currentAnswer.message.taskId &&
                currentAnswer.message.status
              "
              @confirm="submitInput"
              @stop="onStopChatMessage"
            ></TheInput>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="二维码扫描"
      :visible.sync="qrCodeDialogVisible"
      width="30%"
    >
      <img :src="qrcode" alt="" class="qrcode-img" />
    </el-dialog>
  </div>
</template>
<script>
import _ from "lodash";
import VueMarkdown from "vue-markdown";
import QRCode from "qrcode";
import PCMPlayer from "pcm-player";
import { mapState } from "vuex";
import { chatApi } from "@/api/chat-api";
import ScrollListener from "@/util/ScrollListener";
const ANSWER = "answer";
const QUESTION = "question";
const ChatStatus = {
  Pending: "Pending",
  Answering: "Answering",
  Finished: "Finished",
  Stop: "Stop",
  Fail: "Fail",
};

export default {
  components: {
    TheHeader: () => import("@comp/TheHeader.vue"),
    TheHot: () => import("@comp/TheHot.vue"),
    // TheHistory: () => import("@comp/TheHistory.vue"),
    TheInput: () => import("@comp/TheInput.vue"),
    TheMarkdown: () => import("@comp/TheMarkdown.vue"),
    TheSessionHistory: () => import("@comp/TheSessionHistory.vue"),
    VueMarkdown,
  },
  data() {
    return {
      ChatStatus,
      isLiked: false,
      likeImage: require("@/assets/img/thumb-up-line.svg"),
      likedImage: require("@/assets/img/thumb-up-fill.svg"),
      disisLiked: false,
      dislikeImage: require("@/assets/img/thumb-down-line.svg"),
      dislikedImage: require("@/assets/img/thumb-down-fill.svg"),
      guideimg: require("@/assets/img/robot-wave.png"),
      volumeOn: require("@/assets/img/volume-on.svg"),
      volumeMute: require("@/assets/img/volume-mute.svg"),
      inputMessage: "",
      messageList: [],
      feedbackid: "",
      ANSWER: ANSWER,
      QUESTION: QUESTION,
      inputPopoverShow: false,
      inputPopoverTimeoutHandler: null,
      buttons: [],
      rag_buttons: [],
      anchorAttrs: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
      },
      questionMessage: "",
      conversationMess: [], // 存储 AI和用户 会话消息

      searchHistory: [],
      tempInputs: {
        ea_slot: "",
        ea_info: "",
        ea_url: "[]",
        ea_qr_code: "[]",
        ea_slot_record: 0,
        applyFrom: "1",
        history: "",
        choice_type: "0",
        choice_list: "",
        current_preferred_pool: "[]",
        current_ea_pool: "[]",
        in_ea_mark: "0",
        navi_map: "",
        district_flag: this.districtFlag,
        base_district: this.baseDistrict,
        ai_name: this.aiName
      },
      qrCodeDialogVisible: false,
      qrcode: "",
      userId: "abc-123",

      showVideoInputing: true,

      sessionHistory: [
        /* {
            id: '',
            chatMessages: [],
            chatTempInputs: {},
            timestamp: ''
          }*/
      ],
      currentSessionId: "",

      answerAutoScrollTimer: "",
      scrollListener: "",
      hasUserScrollInAnswering: false,
      conversationId: "",

      // tts text
      ttsText: "",
      // ws对象
      websocket: null,
      // 语音合成session
      ttsSession: "",
      // 语音合成ws开关
      ttsRealClose: true,
      // 合成语音WS心跳时间超时时间
      ttsHeartTimerTimeout: 10000,
      // 合成语音WS心跳定时任务
      ttsHeartTimer: null,
      // 合成语音WS重连锁
      ttsWsReconnectLock: false,
      // 合成语音重连定时任务对象
      ttsWsReconnectTimer: null,
      // 合成语音WS客户端监听心跳定时器
      ttsWsTimeoutObj: null,
      // 合成语音音WS服务器端返回监听心跳定时器
      ttsWsServerTimeoutObj: null,
      // 处理PCM音频流的对象
      player: null,
      playAudioEndIndex: 0,
      playAudioFlag: false,
      playAudioTimer: null,
      drawer: false
    };
  },
  computed: {
    ...mapState({
      reasoningModel: (state) => state.business.sysConfig.reasoningModel,
      useConversationId: (state) => state.business.sysConfig.useConversationId,
      WelcomeText: (state) => state.business.sysConfig.WelcomeText,
      WelcomeTitle: (state) => state.business.sysConfig.WelcomeTitle,
      ttsWsUrl: (state) => state.business.sysConfig.ttsWsUrl,
      enableTts: (state) => state.business.sysConfig.enableTts,
      displayCartoon: (state) => state.business.sysConfig.displayCartoon,
      enableAvatar: (state) => state.business.sysConfig.enableAvatar,
      PageTitle: (state) => state.business.sysConfig.PageTitle,
      LogoName: (state) => state.business.sysConfig.LogoName,
      districtFlag: (state) => state.business.sysConfig.districtFlag,
      baseDistrict: (state) => state.business.sysConfig.baseDistrict,
      aiName: (state) => state.business.sysConfig.aiName,
      chatBgUrl: (state) => state.business.sysConfig.chatBgUrl,
      robotHeadUrl: (state) => state.business.sysConfig.robotHeadUrl,
      userAvatarUrl: (state) => state.business.sysConfig.userAvatarUrl,
    }),
    currentAnswer() {
      const index = this.messageList.findLastIndex(
        (item) => item.type === ANSWER
      );
      return {
        index: index,
        message: this.messageList[index],
      };
    },
    shouldShowImage() {
      return this.displayCartoon;
    },
  },
  methods: {
    async toggleFont() {
      await this.$store.dispatch("style/toggleFontSize");
    },
    handleToggleTts(content) {
      if (this.playAudioFlag) {
        this.stopAudioPlay();
      } else {
        if (this.ttsSession) {
          this.wsSendMessage(content);
        } else {
          this.initWebSocket();
          this.initPCMPlayer();
          this.wsSendMessage(content);
        }
      }
    },

    // 初始化音频对象
    initPCMPlayer() {
      this.player = new PCMPlayer({
        encoding: "16bitInt", // 采样位数
        channels: 1, // 通道
        sampleRate: 24000, // 采样率
        flushingTime: 100, // pcm刷新间隔
        onstatechange: () => {},
        // 播放结束事件
        onended: () => {
          // this.resetInactivityTimer(); // 重置全局倒计时
          // 处理其他播放结束逻辑
          if (this.playAudioTimer != null) {
            clearTimeout(this.playAudioTimer);
          }
          this.playAudioTimer = setTimeout(() => {
            this.playAudioFlag = false;
          }, 2000);
        },
      });
      // 设置播放音量大小
      this.player.volume(10);
    },
    countDown() {
      let THIS = this;
      THIS.goIndexTime--;
    },
    // 接收PCM流数据，并播放
    receivePCMStream(audio) {
      if (this.player === undefined || this.player === null) {
        //console.log('receivePCMStream 音频未初始化')
        return;
      }
      this.playAudioFlag = true;
      // 移除Base64字符串中的填充字符（如果有的话）
      audio = audio.replace(/=+$/, "");
      // 将Base64字符串解码为原始的二进制字符串
      var rawString = atob(audio);
      // 计算原始二进制数据的长度（每个字符代表一个字节）
      var rawLength = rawString.length;
      // 创建一个ArrayBuffer来存储解码后的二进制数据
      var buffer = new ArrayBuffer(rawLength);
      // 创建一个指向ArrayBuffer的Uint8Array视图
      var arraybuffer2 = new Uint8Array(buffer);
      // 将每个字符的ASCII值复制到Uint8Array视图中
      for (var i = 0; i < rawLength; i++) {
        arraybuffer2[i] = rawString.charCodeAt(i);
      }
      // 现在uint8Array包含了解码后的二进制数据
      this.player.feed(arraybuffer2.buffer);
    },
    // 续播音频
    playAudio() {
      if (this.player !== undefined && this.player !== null) {
        this.player.continue();
      }
    },
    // 暂停音频
    pauseAudio() {
      if (this.player !== undefined && this.player !== null) {
        this.player.pause();
      }
    },
    // 停止语音播放
    stopAudioPlay() {
      this.closeWs();
      this.playAudioEndIndex = 0;
      this.playAudioFlag = false;
      if (this.player != null) {
        this.player.destroy();
        this.player = null;
      }
    },
    // 语音播报
    // 初始化文字转语音WebSocket
    initWebSocket() {
      // 判断当前浏览器是否支持WebSocket
      if ("WebSocket" in window) {
        try {
          if (this.enableTts) {
            if (this.ttsWebsocket && this.ttsWebsocket.readyState === 1) {
              this.ttsWebsocket.close();
            }
            this.ttsWebsocket = new WebSocket(this.ttsWsUrl + this.userId);
            this.ttsWebsocket.onmessage = this.ttsWsOnMessage;
            this.ttsWebsocket.onopen = this.ttsWsOnOpen;
            this.ttsWebsocket.onerror = this.ttsWsOnError;
            this.ttsWebsocket.onclose = this.ttsWsOnClose;
          } else {
            console.log("没有启用文字转语音");
          }
        } catch (err) {
          this.$message.error("初始化文字转语音WebSocket异常！");
          this.ttsWsReconnect();
        }
      } else {
        this.$message.error("当前浏览器不支持WebSocket！");
      }
    },
    // ws接收到服务端发送的消息
    ttsWsOnMessage(event) {
      if (event.data === "HeartBeat") {
        //console.log('ttsWsOnMessage WebSocket: 心跳检测响应')
        this.ttsWsStartHeart();
        return;
      }
      let dataJson = JSON.parse(event.data);
      // console.log("----:",dataJson)
      if (
        dataJson.session !== undefined &&
        dataJson.session !== null &&
        dataJson.session !== ""
      ) {
        this.ttsSession = JSON.parse(event.data).session;
      }
      if (dataJson.status === 1 && dataJson.audio !== "") {
        this.receivePCMStream(dataJson.audio);
      }
    },
    // 打开ws连接时触发的事件
    ttsWsOnOpen() {
      this.ttsWsStartHeart();
    },
    // 发生错误时触发的事件
    ttsWsOnError() {
      this.ttsWsReconnect();
    },
    // 连接关闭时触发的事件
    ttsWsOnClose() {
      this.ttsWsCleanHeart();
      if (!this.ttsRealClose) {
        this.ttsWsReconnect();
      }
    },
    // ws发送消息给后端
    wsSendMessage(content) {
      console.log("tts wsSendMessage");

      let params = {
        text: content,
        spk_id: 0,
      };
      if (this.ttsWebsocket && this.ttsWebsocket.readyState === 1) {
        //console.log('tts readyState sendMessage');
        this.ttsWebsocket.send(JSON.stringify(params));
      } else {
        setTimeout(() => {
          //console.log('tts 1s 后发送')
          this.wsSendMessage(content);
        }, 1000);
      }
    },
    // 关闭语音合成ws
    closeWs() {
      if (
        this.ttsSession !== undefined &&
        this.ttsSession !== null &&
        this.ttsSession !== ""
      ) {
        let params = {
          task: "tts",
          signal: "end",
          session: this.ttsSession,
        };
        console.log("关闭ws: ", params);
        this.ttsWebsocket.send(JSON.stringify(params));
        this.ttsSession = "";
      }
      this.ttsWsCleanHeart();
      this.ttsRealClose = true;
      if (this.ttsWebsocket && this.ttsWebsocket.readyState === 1) {
        this.ttsWebsocket.close();
      }
      if (this.player !== undefined && this.player !== null) {
        this.player.destroy();
        this.player = null;
      }
    },
    // 语音合成重连
    ttsWsReconnect() {
      const that = this;
      if (that.ttsWsReconnectLock) {
        return;
      }
      that.ttsWsReconnectLock = true;
      that.ttsWsReconnectTimer && clearTimeout(that.ttsWsReconnectTimer);
      that.ttsWsReconnectTimer = setTimeout(() => {
        //console.log("ttsWsReconnect WebSocket: 重连中...");
        that.ttsWsReconnectLock = false;
        // websocket启动
        that.initWebSocket();
      }, 4000);
    },
    // 语音合成清除心跳检测机制
    ttsWsCleanHeart() {
      const that = this;
      clearTimeout(that.ttsWsTimeoutObj);
      clearTimeout(that.ttsWsServerTimeoutObj);
    },
    // 语音合成心跳检测启动
    ttsWsStartHeart() {
      const that = this;
      clearTimeout(that.ttsWsTimeoutObj);
      clearTimeout(that.ttsWsServerTimeoutObj);

      that.ttsWsTimeoutObj && clearTimeout(that.ttsWsTimeoutObj);
      that.ttsWsServerTimeoutObj && clearTimeout(that.ttsWsServerTimeoutObj);

      that.ttsWsTimeoutObj = setTimeout(() => {
        // 这里向后端发送一个心跳检测，后端收到后，会返回一个心跳回复
        that.ttsWebsocket.send("HeartBeat");
        //console.log("ttsWsStartHeart WebSocket: 发送心跳检测");

        that.ttsWsServerTimeoutObj = setTimeout(() => {
          // 如果超过一定时间还没重置计时器，说明websocket与后端断开了
          that.ttsWebsocket.close();
          //console.log("ttsWsStartHeart WebSocket: 未收到心跳检测回复");
        }, that.ttsHeartTimerTimeout);
      }, that.ttsHeartTimerTimeout);
    },

    onShowQrCode(message) {
      let text = message.eaUrl[0];
      QRCode.toDataURL(text, { width: 192, margin: 1 }).then((res) => {
        this.qrcode = res;
        this.qrCodeDialogVisible = true;
      });
    },
    handleLike(content, messageid) {
      this.isLiked = !this.isLiked;
      document
        .getElementById("like" + messageid)
        .setAttribute(
          "src",
          this.isLiked
            ? this.likedImage
            : require("@/assets/img/thumb-up-line.svg")
        );
      if (this.isLiked) {
        this.disisLiked = false;
        document
          .getElementById(messageid)
          .setAttribute("src", require("@/assets/img/thumb-down-line.svg"));
        chatApi.feedBackMessage(this.feedbackid, "like", content, this.userId);
      }
    },
    handleDislike(content, messageid) {
      this.disisLiked = !this.disisLiked;
      document
        .getElementById(messageid)
        .setAttribute(
          "src",
          this.disisLiked
            ? this.dislikedImage
            : require("@/assets/img/thumb-down-line.svg")
        );
      // this.dislikeImage = this.disisLiked? this.dislikedImage : require('@/assets/img/thumb-down-line.svg');
      if (this.disisLiked) {
        this.isLiked = false;
        // this.likeImage = require('@/assets/img/thumb-up-line.svg');
        document
          .getElementById("like" + messageid)
          .setAttribute("src", require("@/assets/img/thumb-up-line.svg"));
        chatApi.feedBackMessage(
          this.feedbackid,
          "dislike",
          content,
          this.userId
        );
      }
    },
    handleCopy(content) {
      var _this = this;
      try {
        navigator.clipboard.writeText(content);
        _this.$message.success("文本复制成功");
      } catch (error) {
        console.error("文本复制失败:", error);
      }
    },
    onStopChatMessage() {
      var _this = this;
      let params = {
        user: this.userId,
      };
      chatApi
        .stopChat(this.currentAnswer.message.taskId, params)
        .then((ret) => {
          if (ret.result === "success") {
            const message = this.messageList[this.currentAnswer.index];
            message.status = ChatStatus.Stop;
            if (!message.content) {
              message.content = "回答已停止";
            }
            this.updateMessageInConversation(message);
            _this.$message.success("停止回答成功");
            this.guideimg = require("@/assets/img/robot-blink.png");
          }
        })
        .catch((error) => {
          console.error(error);
          this.$message.error("停止回答失败");
        });
    },
    onGetMoreInfo() {
      this.submitInput("相关推荐", false);
    },
    handleChoiceItem(row) {
      this.submitInput(row, false);
    },
    onHotClick(item) {
      this.stopAudioPlay();
      this.closeWs();
      this.submitInput(item.text);
    },
    resetTempInputs(tempInputs) {
      if (!tempInputs) {
        this.tempInputs = {
          ea_slot: "",
          ea_info: "",
          ea_url: "[]",
          ea_qr_code: "[]",
          ea_slot_record: 0,
          history: "",
          choice_type: "0",
          choice_list: "",
          current_preferred_pool: "[]",
          current_ea_pool: "[]",
          in_ea_mark: "0",
          applyFrom: "1",
          district_flag: this.districtFlag,
          base_district: this.baseDistrict,
          ai_name: this.aiName
        };
      } else {
        this.tempInputs = tempInputs;
      }
    },
    onOpenNewSession() {
      this.stopAudioPlay();
      this.closeWs();
      this.drawer = false
      if (!this.currentSessionId) {
        return;
      }
      this.currentSessionId = "";
      this.conversationId = "";
      this.messageList = [];
      this.sendWelcomeText();
      this.resetTempInputs();

    },
    onDelSessionItem(sessionId) {
      console.log(sessionId);
      let index = _.findIndex(this.sessionHistory, ["id", sessionId]);
      this.sessionHistory.splice(index, 1);
      localStorage.setItem(
        "SessionHistory",
        JSON.stringify(this.sessionHistory)
      );
      this.onOpenNewSession();
    },
    onHistoryClick(item) {
      // 展示会话
      console.log(item);
      if (this.currentSessionId === item.id) {
        return;
      }
      // 回显之前会话内容
      this.currentSessionId = item.id;
      this.messageList = [].concat(item.chatMessages);
      this.resetTempInputs(item.chatTempInputs);
      this.scrollToBottom(item.chatMessages[item.chatMessages.length - 1]);
    },
    onClearClick() {
      this.sessionHistory = [];
      localStorage.removeItem("SessionHistory");
      this.onOpenNewSession();
    },
    getUUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    // 生成消息
    messageCreator(
      type,
      content = "",
      title,
      status = ChatStatus.Pending,
      reasoningModel = false
    ) {
      return {
        id: this.getUUID(),
        time: new Date().getTime(),
        title: title,
        type: type,
        content: `${content}`,
        think: "",
        inThink: reasoningModel,
        reasoningModel: reasoningModel,
        status: status,
        taskId: "",
      };
    },
    addMessage2Conversation(message) {
      this.messageList.push(message);
      this.inputMessage = "";
      this.scrollToBottom(message);
    },
    scrollToBottom(message) {
      console.log(message);
      this.scrollListener.checkUserScroll((isUserScrolling) => {
        console.log("用户滚动" + isUserScrolling);
        this.hasUserScrollInAnswering = isUserScrolling;
        if (isUserScrolling) {
          clearTimeout(this.answerAutoScrollTimer);
        }
      });

      if (!this.hasUserScrollInAnswering) {
        this.answerAutoScrollTimer = setTimeout(() => {
          let messageDom = document.querySelector(`#m-${message.id}`);
          messageDom.scrollIntoView({ behavior: "smooth", block: "end" });
        }, 10);
      }
    },
    updateMessageInConversation(message) {
      const index = _.findIndex(this.messageList, ["id", message.id]);
      this.messageList[index].content = message.content;
      this.messageList[index].title = message.title;

      for (var key in message) {
        if (["title", "content"].indexOf(key) === -1) {
          this.$set(this.messageList[index], key, message[key]);
        }
      }
      this.updateSearchHistory(message);
      this.scrollToBottom(message);
    },
    ragbuttonHandle(message) {
      this.submitInput(message);
    },
    buttonHandle(content, message) {
      console.log(content);
      content = this.getTextAfterSecondThinkTag(content);
      console.log(content);
      var arr = "";
      var message1 = message + "**";
      const startIndex = content.indexOf(message1);
      if (startIndex === -1) {
        arr = "";
      }
      // 从 message 首次出现的位置之后开始查找 **
      const endIndex = content.indexOf("**", startIndex + message1.length);
      if (endIndex === -1) {
        arr = "";
      } else if (content.slice(startIndex, endIndex).length > 0) {
        arr = "**" + content.slice(startIndex, endIndex);
      }
      if (arr) {
        this.submitInputWithAnswer(message, arr);
      } else {
        this.submitInput(message);
      }
    },
    getTextAfterSecondThinkTag(text) {
      const lastIndex = text.lastIndexOf("</think>");
      if (lastIndex === -1) {
        // 如果没有找到 </think> 标签，返回原字符串
        return text;
      }
      // 截取最后一个 </think> 标签之后的数据
      return text.slice(lastIndex + 8);
    },
    // 输入框提交事件
    submitInputWithAnswer(message, answer) {
      if (!this.currentSessionId) {
        this.currentSessionId = this.getUUID();
        this.sessionHistory.push({
          id: this.currentSessionId,
          chatMessages: [].concat(this.messageList.concat()),
          chatTempInputs: this.tempInputs,
          timestamp: new Date().getTime(),
        });
      }

      this.inputMessage = message;
      this.questionMessage = this.inputMessage;

      // 添加问的内容
      let question = this.messageCreator(
        QUESTION,
        this.inputMessage,
        "",
        ChatStatus.Finished
      );
      this.addMessage2Conversation(question);
      this.addSearchHistory(question);

      // 添加回答等待效果
      let emptyAnswer = this.messageCreator(ANSWER);
      this.addMessage2Conversation(emptyAnswer);
      this.addSearchHistory(emptyAnswer);

      // 请求服务器
      const id = emptyAnswer.id;
      emptyAnswer.status = ChatStatus.Finished;
      emptyAnswer.content = answer;
      emptyAnswer.id = id;
      emptyAnswer.title = "为您找到这些";
      this.updateMessageInConversation(emptyAnswer);
      this.guideimg = require("@/assets/img/robot-happy.png");
    },
    submitInput(message) {
      this.hasUserScrollInAnswering = false;

      if (!this.currentSessionId) {
        this.currentSessionId = this.getUUID();
        this.sessionHistory.push({
          id: this.currentSessionId,
          chatMessages: [].concat(this.messageList.concat()),
          chatTempInputs: this.tempInputs,
          timestamp: new Date().getTime(),
        });
      }

      this.inputMessage = message;
      this.questionMessage = this.inputMessage;

      // 添加问的内容
      let question = this.messageCreator(
        QUESTION,
        this.inputMessage,
        "",
        ChatStatus.Finished
      );
      this.addMessage2Conversation(question);
      this.addSearchHistory(question);

      // 添加回答等待效果
      // 判断是否是思考模型
      let emptyAnswer;
      if (this.reasoningModel) {
        emptyAnswer = this.messageCreator(
          ANSWER,
          "",
          "",
          ChatStatus.Pending,
          true
        );
      } else {
        emptyAnswer = this.messageCreator(ANSWER);
      }
      this.addMessage2Conversation(emptyAnswer);
      this.addSearchHistory(emptyAnswer);

      // 请求服务器
      this.searchAnswer(emptyAnswer);
    },

    addSearchHistory(message) {
      const index = _.findIndex(this.sessionHistory, [
        "id",
        this.currentSessionId,
      ]);
      const searchHistory = this.sessionHistory[index].chatMessages;
      searchHistory.push(message);
      localStorage.setItem(
        "SessionHistory",
        JSON.stringify(this.sessionHistory)
      );
    },
    updateSearchHistory(message) {
      const sessionIndex = _.findIndex(this.sessionHistory, [
        "id",
        this.currentSessionId,
      ]);
      this.sessionHistory[sessionIndex].chatTempInputs = this.tempInputs;
      const searchHistory = this.sessionHistory[sessionIndex].chatMessages;
      const messageIndex = _.findIndex(searchHistory, ["id", message.id]);
      searchHistory[messageIndex] = message;
      localStorage.setItem(
        "SessionHistory",
        JSON.stringify(this.sessionHistory)
      );
    },
    removeConversationMessById(id) {
      // 根据id移除会话
      _.remove(this.messageList, ["id", id]);
    },
    searchAnswer(message) {
      this.stopAudioPlay();
      this.closeWs();
      this.initWebSocket();
      this.initPCMPlayer();
      var that = this;
      that.ttsText = "";
      var abortController = new AbortController();
      message.status = ChatStatus.Pending;
      const id = message.id;
      this.tempInputs.applyFrom = "1";
      chatApi.startChat({
        body: JSON.stringify({
          inputs: {
            ...this.tempInputs,
            district_flag: this.districtFlag,
            base_district: this.baseDistrict,
            ai_name: this.aiName
          },
          query: this.questionMessage,
          response_mode: "streaming",
          conversation_id: this.conversationId,
          user: this.userId,
        }),
        openWhenHidden: true, // 页面文档被隐藏时会关闭sse链接并在显示时重连 true无论隐藏与否都不关闭
        signal: abortController.signal, // AbortSignal
        onmessage: async (ev) => {
          // 接收到消息之后填充消息数据
          const data = JSON.parse(ev.data);

          const event = data.event;
          if (event === "workflow_started") {
            message.id = id;
            message.taskId = data.task_id;
            message.status = ChatStatus.Answering;
            this.guideimg = require("@/assets/img/robot-think.png");
            this.updateMessageInConversation(message);
          } else if (event === "message") {
            if (message.status === ChatStatus.Stop) return;
            if (message.reasoningModel) {
              if (message.inThink) {
                message.think += data.answer;
                if (message.think.indexOf("</think>") > -1) {
                  let arr = message.think.split("</think>");
                  message.think = arr[0];
                  message.inThink = false;
                  message.content += arr[1];
                  that.ttsText += arr[1];
                }
              } else {
                message.content += data.answer;
                that.ttsText += data.answer;
              }
            } else {
              message.content += data.answer;
              that.ttsText += data.answer;
            }
            if (that.ttsText.length > 20) {
              this.wsSendMessage(that.ttsText);
              that.ttsText = "";
            }

            message.id = id;
            message.title = "为您找到这些";
            message.taskId = data.task_id;
            this.feedbackid = data.message_id;
            message.status = ChatStatus.Answering;
            this.updateMessageInConversation(message);
          } else if (event === "node_finished") {
            const result = data.data;
            if (result.status !== "succeeded") {
              console.error("node_finished出错了：");
              console.error(result.error);
              return;
            }

            const outputs = result.outputs;
            if (!outputs || !outputs.end_flag || outputs.end_flag !== 1) {
              // 未结束，不做处理
              return;
            }

            this.tempInputs = outputs;

            console.log("node_finished");
            console.log(outputs);
            if (outputs.matched_button) {
              that.buttons = eval(outputs.matched_button);
            }
            if (outputs.rag_item) {
              that.rag_buttons = eval(outputs.rag_item);
            }
            // 完成后处理
            message.title = "为您找到这些";
            message.id = id;

            message.relevantKnowledgeList = outputs.relevantKnowledgeList || [];
            message.relevantEaList = outputs.relevantEaList || [];
            message.eaUrl = outputs.ea_url || "";
            message.matched_button = outputs.matched_button || "";
            message.rag_item = outputs.rag_item || "";
            message.answerType = outputs.answer_type || "";
            this.guideimg = require("@/assets/img/robot-happy.png");
            console.log("outputs.choice_list");
            console.log(outputs.choice_list);
            try {
              if (outputs.choice_list) {
                message.choiceList = JSON.parse(outputs.choice_list);
              } else {
                message.choiceList = "";
              }
            } catch (e) {
              console.error(e);
              message.choiceList = "";
            }

            message.taskId = data.task_id;
            message.status = ChatStatus.Finished;
            if (that.ttsText.length > 0) {
              this.wsSendMessage(that.ttsText);
              that.ttsText = "";
            }

            this.updateMessageInConversation(message);
          } else if (event === "error") {
            // 提示错误信息
            console.log(data.message);
            message.title = "请求失败";
            message.status = ChatStatus.Fail;
            message.content = "请求失败，请重试";
            this.updateMessageInConversation(message);
            this.guideimg = require("@/assets/img/robot-sad.png");
          } else if (event === "message_end") {
            // 消息结束事件，收到此事件则代表流式返回结束
            if (message.status === ChatStatus.Answering) {
              message.status = ChatStatus.Finished;
            }
            if (this.useConversationId) {
              // 启用对话Id
              this.conversationId = data.conversation_id;
            }
          }
        },
        onopen: (res) => {
          // 打开
          if (res.status !== 200) {
            console.error("chatMessage失败：", res);
            message.title = "请求失败";
            message.status = ChatStatus.Fail;
            message.content = "很抱歉，服务器开小差了，请您稍后再试";
            this.guideimg = require("@/assets/img/robot-sad.png");
            this.updateMessageInConversation(message);
          }
        },
        onclose: () => {
          // 连接关闭
          setTimeout(() => {
            this.guideimg = require("@/assets/img/robot-magic.png");
          }, 4000); // 2000 毫秒即 2 秒
          console.log("连接关闭");
        },
        onerror: (err) => {
          // 失败
          abortController.abort();
          console.error("chatMessage失败：", err);
          message.title = "请求失败";
          message.status = ChatStatus.Fail;
          message.content = "很抱歉，服务器开小差了，请您稍后再试";
          this.guideimg = require("@/assets/img/robot-sad.png");
          this.updateMessageInConversation(message);
        },
      });

      /* this.updateMessageInConversation(emptyMessage.id, res, '为您找到这些');

            this.updateMessageInConversation(
              emptyMessage.id,
              `<p>${err}</p>
              <p>[自动回复] 当前系统繁忙，请稍后...</p>
              <p class="link">
                <a href="http://www.baidu.com" target="_blank">去网上看看</a>
              </p>`,
              '出问题了。。。'
            );*/
    },
    sendWelcomeText() {
      this.addMessage2Conversation(
        this.messageCreator(
          ANSWER,
          this.WelcomeText,
          this.WelcomeTitle,
          ChatStatus.Finished
        )
      );
    },
    handleWindowResize() {
      this.drawer = false
    }
  },
  mounted() {
    var sessionHistory = localStorage.getItem("SessionHistory");
    if (sessionHistory) {
      this.sessionHistory = JSON.parse(sessionHistory);
    }

    this.scrollListener = new ScrollListener(this.$refs.chatWrap);

    this.resetTempInputs()

    this.sendWelcomeText();

    window.addEventListener("resize", this.handleWindowResize)
  },
};
</script>

<style>
blockquote {
  color: #8b8b8b;
  white-space: pre-wrap;
  margin: 0;
  padding: 0 0 0 13px;
  line-height: 26px;
  position: relative;
}
</style>

<style lang="scss" scoped>
@import "~@/assets/css/_var.scss";
.buttonContainer {
  display: flex;
  flex-wrap: wrap;
  gap: 10px; /* 按钮间距 */
  margin-top: 16px;
  ::v-deep {
    .el-button {
      flex: 0 0 calc(25% - 10px);
      box-sizing: border-box; /* 防止边框影响布局 */ /* 可选样式 */
      padding: 10px;
      margin: 0; /* 清除默认 margin */
      text-align: center;
      white-space: nowrap; /* 防止文字换行 */
    }
  }
}
.page {
  .layout {
    margin: 0 auto;
    width: 100vw;
    max-width: 1410px;
  }
  .qrcode-img {
    display: block;
    margin: 0 auto;
  }
  .main {
    display: flex;
    // height: 720px;
    height: calc(100vh - #{$headerHeight} - 40px);
    min-height: 530px;
    // width: 100vw;
    // max-width: 1410px;
    // width: 1200px;
    position: relative;
    // background: #fff;
    border-radius: 14px;
  }
  .mobile-header {
    display: none;
  }
  @media screen and (max-width: 768px) {
    .main {
      height: calc(100vh - #{$headerHeight});
      min-height: auto;
    }
    .aside {
      display: none;
    }
    .mobile-header {
      display: block;
      margin-left: 20px!important;
      margin-right: 20px!important;
      padding-top: 20px!important;
      font-size: 22px;
      .icon-button {
        line-height: 2.3rem;
      }
      .mobile-title {
        font-weight: bold;
        color: rgba(69, 125, 255, 1);
        display: flex;
        justify-content: center;
      }
      i {
        color: rgba(69, 125, 255, 1);
      }
    }
    .chat {
      margin: 20px;
      border-radius: 10px;
      box-shadow: 0 4px 8px 0 rgba(78, 159, 247, 0.6),
        0 6px 15px 0 rgba(78, 159, 247, 0.6);
    }
  }

  .aside {
    // display: none;
    padding-top: 28px;
    width: $sideWidth;
    background: rgba(246, 249, 254, 1);
  }

  .chat {
    width: 100%;
    font-size: var(--font-size);
    background: url("~@img/chat-bg.png") no-repeat bottom right;
    background: linear-gradient(to bottom, #ecf0ffcc, #ffffffcf);
    background-size: 100% 100%;
    // background-position: 100% 100%;
    padding: 10px 0;

    .input-wrap {
      margin: 0 20px;
      position: relative;
      z-index: 99;
    }
    ::v-deep .the-input {
      width: 100%;
    }
  }

  .chat-wrapper {
    // height: $chatHeight;
    height: calc(100% - #{$inputHeight});
    // width: $chatWidth;
    position: relative;
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    .stop-answer {
      text-align: center;
      z-index: 2;
      margin-top: 10px;
      .btn-stop-answer {
        border-radius: 10px;
      }
    }
  }

  .chat-wrap {
    // height: $chatHeight;
    // width: $chatWidth;
    overflow-y: auto;
    padding: 0 20px;

    .chat-item {
      width: 100%;

      & + .chat-item {
        margin-top: 14px;
      }

      .avatar {
        display: flex;
        align-items: center;
        user-select: none;

        img {
          width: 50px;
        }

        .talk {
          font-weight: bold;
          //font-size: 16px;
          user-select: none;
          margin: 0 14px;
        }
      }

      .message {
        padding: 0 20px;
        // max-width: calc(100% - #{$avatarWidth} * 2 - 40px);

        .text {
          box-shadow: 0 0 8px #e4e4e4;
          margin-top: 10px;
          border-radius: 10px;
          //position: relative;

          .wrap {
            height: 100%;
            width: 100%;
            padding: 10px 20px;
            line-height: 2;
            background: #fff;
            border-radius: 10px;
            //z-index: 10;
            //position: relative;
            border-radius: 0 10px 10px 10px;

            .finished-tool {
              text-align: right;
              margin-top: 10px;
            }

            .related-matters {
              text-align: left;
              margin-top: 10px;
              position: relative;
              ::v-deep .el-popover {
                top: auto !important;
                bottom: 30px !important;
              }
            }
          }
        }
      }

      &.self {
        display: flex;
        justify-content: flex-end;

        .text {
          .wrap {
            background: linear-gradient(
              90deg,
              rgba(38, 111, 235, 1) 0%,
              rgba(66, 135, 255, 1) 100%
            );
            color: #fff;
            border-radius: 10px 0 10px 10px;
          }
        }
      }
    }
  }
}
.icon-buttons {
  margin-top: 10px; /* 这里的 20px 可以根据需要调整为合适的间距值 */
  display: flex;
  gap: 10px;
  background: none;
  border: 1px solid #ccc; /* 设置边框 */
  border-radius: 20px; /* 设置圆角 */
  padding: 5px; /* 设置内边距 */
  display: inline-flex; /* 使用 inline-flex 使容器宽度自适应内容 */
  gap: 10px; /* 设置按钮之间的间距 */
}
.logo {
  position: absolute;
  z-index: 80 !important;
  left: 0;
  top: 0;
  width: 200px;
  height: 200px;
  transform: translate(0, -80%);
}
</style>
